import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from "@azure/msal-angular";
import { AuthenticationResult, InteractionRequiredAuthError, InteractionType } from "@azure/msal-browser";
import * as CryptoJS from "crypto-js";

import { EMPTY, Observable, throwError } from "rxjs";
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from "../../environments/environment";

const SECURITY_USER_KEY_PLAINTEXT = environment.securityKey;
const SECURITY_USER_KEY_AES_KEY = CryptoJS.enc.Utf8.parse("PSVJQRk9QTEpNVU1DWUZCRVFGV1VVT0=");
const SECURITY_USER_KEY_IV = CryptoJS.enc.Utf8.parse("2314345645678765");

@Injectable()
export class RequestHeadersInterceptor implements HttpInterceptor {
    private nextRequest: boolean = true;

    constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private authService: MsalService,) { }

    private encryptSecurityUserKey(data: string): string {
        return CryptoJS.AES.encrypt(data, SECURITY_USER_KEY_AES_KEY, {
            keySize: 128 / 8,
            iv: SECURITY_USER_KEY_IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString();
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const scopes = [environment.apiClientID];
        const accounts = this.authService.instance.getAllAccounts();
        const account = accounts[0];
        return this.authService.acquireTokenSilent({ scopes, account }).pipe(
            catchError((error: any): Observable<AuthenticationResult> => {
                if (error instanceof InteractionRequiredAuthError) {
                    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
                        return this.authService.acquireTokenPopup({
                            ...this.msalGuardConfig.authRequest,
                            scopes
                        });
                    } else if (this.msalGuardConfig.interactionType === InteractionType.Redirect) {
                        this.authService.acquireTokenRedirect({
                            ...this.msalGuardConfig.authRequest,
                            scopes
                        });
                        return EMPTY; // Redirect will take the user away
                    }
                }

                return throwError(() => error);
            }),
            switchMap((result: AuthenticationResult) => {
                const securityUserKey = this.encryptSecurityUserKey(SECURITY_USER_KEY_PLAINTEXT);
                const headers = req.headers
                    .set('Authorization', `Bearer ${result.accessToken}`)
                    .set('ApiKey', securityUserKey);

                const requestClone = req.clone({ headers });
                return next.handle(requestClone);
            })
        );
    }
}


